import { BrandNames } from 'mp-cross';
/**
 * Temporal comparison against hardcoded string due to an error using the enum.
 */
export const enabledRebranding = (appTheme: BrandNames): boolean => appTheme === 'yellowblue-light';
